import type { SoundEffectFacets } from '../../data/sound-effect.dto.ts'
import type { SoundEffectParameters } from '../models/sound-effect-parameters.ts'

export const mapSoundEffectFacetsToSoundEffectFilters = (
  facet: SoundEffectFacets
): SoundEffectParameters => ({
  tags: facet['labels.as.category.display_values'] ?? {},
})
